import component from './de-DE/component';
import globalHeader from './de-DE/globalHeader';
import menu from './de-DE/menu';
import pages from './de-DE/pages';
import pwa from './de-DE/pwa';
import settingDrawer from './de-DE/settingDrawer';
import settings from './de-DE/settings';

export default {
  'navBar.lang': 'Sprache',
  'layout.user.link.help': 'Hilfe',
  'layout.user.link.privacy': 'Datenschutz',
  'layout.user.link.terms': 'Bedingungen',
  'app.preview.down.block': 'Diese Seite in das lokale Projekt herunterladen',
  'app.welcome.link.fetch-blocks': 'Abrufen aller Blöcke',
  'app.welcome.link.block-list': 'Erstellen Sie schnell standardisierte Seiten basierend auf dem Blockentwicklungsframework',

  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
};
